export default __webpack_public_path__ + "static/media/dtronics.7b345a6d.png";